module.exports = __webpack_public_path__ + "img/配件.5f0d6a3a.png";